export const CHANGE_CURRENT_PAGE = 'regions/CHANGE_CURRENT_PAGE'
export const CREATE_REGION = 'regions/CREATE_REGION'
export const FETCH_REGIONS_LIST = 'regions/FETCH_REGIONS_LIST'
export const FETCH_REGION = 'regions/FETCH_REGION'
export const FETCH_REGIONS_FOR_OPTIONS = 'regions/FETCH_REGIONS_FOR_OPTIONS'
export const REMOVE_REGION = 'regions/REMOVE_REGION'
export const UPDATE_REGION = 'regions/UPDATE_REGION'
